module.exports = __webpack_public_path__ + "img/img11.a8c367a9.svg";